import { markerIconDefaultColor } from './config';

class MarkerIconStyleProvider {
	constructor() {
		this.defaultColor = markerIconDefaultColor;
		this.customColor = {};
	}

	getColor(id) {
		if (id in this.customColor) {
			return this.customColor[id];
		}

		return this.getDefaultColor(id);
	}

	getDefaultColor(id) {
		return this.defaultColor[id.startsWith("search-result-") ? "search-result" : id];
	}

	setColor(id, color) {
		if (color.toLowerCase() == this.getDefaultColor(id).toLowerCase()) {
			if (id in this.customColor) {
				delete this.customColor[id];
			}
		} else {
			this.customColor[id] = color;
		}
	}

	getCjaIconProps(ojsId) {
		let color = '';
		let iconColor = '#fff';
		let number = ojsId;

		if (number.length !== 1) {
			// this is not pohranici
			const firstDigit = number.charAt(0);
			switch(firstDigit) {
			case '1':
				color = '#53ac62';
				break;
			case '2':
				color = '#cf8a30';
				break;
			case '3':
				color = '#12a0ed';
				break;
			case '4':
				color = '#ee6c44';
				break;
			case '5':
				color = '#ffea00';
				iconColor = '#1a1a1a';
				break;
			case '6':
				color = '#4657b9';
				break;
			case '7':
				color = '#b7c837';
				iconColor = '#1a1a1a';
				break;
			case '8':
				color = '#a9390a';
				break;
			case '9':
				color = '#7a7a85';
				break;
			}
		} else {
			color = '#a6a6a6';
			iconColor = '#1a1a1a';
			number = `0${number}`;
		}

		return {
			icon: 'fa-number',
			iconColor,
			number,
			markerColor: color,
			shape: 'square',
			prefix: 'fas',
			svg: true,
		};
	}
}

export default new MarkerIconStyleProvider();
